import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { emailThunks } from './emailThunks';
import type { EmailState } from './emailTypes';

const initialState: EmailState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  filters: {},
  totalCount: 0,
};

export const emailSlice = createSlice({
  name: 'emails',
  initialState,
  reducers: {
    setEmailFilters(state, action: PayloadAction<Partial<EmailState['filters']>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearEmailFilters(state) {
      state.filters = {};
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, emailThunks, (e) => e.emailId);
  },
});

export const { setEmailFilters, clearEmailFilters } = emailSlice.actions;
export const emailReducer = emailSlice.reducer;
